import { render } from "./page_context_menu.vue?vue&type=template&id=0c811708"
import script from "./page_context_menu.vue?vue&type=script&lang=js"
export * from "./page_context_menu.vue?vue&type=script&lang=js"

import exportComponent from "/app/docuseal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"app/javascript/template_builder/page_context_menu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0c811708"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0c811708', __exports__)) {
    api.reload('0c811708', __exports__)
  }
  
  module.hot.accept("./page_context_menu.vue?vue&type=template&id=0c811708", () => {
    api.rerender('0c811708', render)
  })

}


export default __exports__